const round = (value, initial, final) => value < (final - initial) / 2 ? initial : final
const { isArray } = Array
const isNonEmptyArray = (value) => isArray(value) && value.length > 0
const isEmptyArray = (value) => !isArray(value) || value.length < 1

export { round, isArray, isNonEmptyArray, isEmptyArray }
